module.exports = __webpack_public_path__ + "static/media/illustration_questionnaire.a2a99085.svg";